/** One switchboard for the paused still-photography offering. Keep page implementations for a future relaunch. */
export const isPausedPhotoPath = (path: string): boolean =>
  /^\/(?:foto|en\/photography)(?:\/|$)/.test(path) ||
  /^\/branschstudier\/bildindex-2026\/?$/.test(path) ||
  path === "/api/public/bildindex-2026.csv";
